(() => {
  const storageKey = 'asap-compare-handles-v1';
  const handlePattern = /^[a-z0-9][a-z0-9-]*$/;
  const limit = 3;

  function validHandles(handles) {
    const selected = [];
    for (const handle of handles || []) {
      const value = String(handle || '').trim();
      if (!handlePattern.test(value) || selected.includes(value)) continue;
      selected.push(value);
      if (selected.length === limit) break;
    }
    return selected;
  }

  function readHandles() {
    try {
      return validHandles(JSON.parse(window.sessionStorage.getItem(storageKey) || '[]'));
    } catch (error) {
      return [];
    }
  }

  let handles = readHandles();

  function persist() {
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(handles));
    } catch (error) {
      // Compare remains usable when private browsing blocks session storage.
    }
  }

  function compareUrl(root) {
    const base = root.dataset.asapComparePath || '/pages/compare?view=compare';
    if (!handles.length) return base;
    return `${base}${base.includes('?') ? '&' : '?'}products=${handles.join(',')}`;
  }

  function announce(root, message) {
    const liveRegion = root.querySelector('[data-asap-compare-live]');
    if (liveRegion) liveRegion.textContent = message;
  }

  function render(root) {
    root.querySelectorAll('[data-asap-compare-toggle]').forEach((button) => {
      const selected = handles.includes(button.dataset.asapProductHandle);
      button.setAttribute('aria-pressed', String(selected));
      button.textContent = selected ? 'Remove from Compare' : 'Compare';
    });
    root.querySelectorAll('[data-asap-compare-link]').forEach((link) => {
      link.href = compareUrl(root);
      link.hidden = handles.length === 0;
      link.textContent = `Compare selected (${handles.length})`;
    });
  }

  function renderAll() {
    document.querySelectorAll('[data-asap-compare-root]').forEach(render);
  }

  function toggle(handle) {
    const value = String(handle || '').trim();
    if (!handlePattern.test(value)) return false;
    const index = handles.indexOf(value);
    if (index !== -1) {
      handles.splice(index, 1);
      persist();
      renderAll();
      return true;
    }
    if (handles.length >= limit) {
      document.querySelectorAll('[data-asap-compare-root]').forEach((root) => announce(root, 'You can compare up to three scooters. Remove one before adding another.'));
      return false;
    }
    handles.push(value);
    persist();
    renderAll();
    return true;
  }

  function clear() {
    handles = [];
    persist();
    renderAll();
  }

  function initialize(root) {
    if (root.dataset.asapCompareReady === 'true') return;
    root.dataset.asapCompareReady = 'true';
    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-asap-compare-toggle]');
      if (!button || !root.contains(button)) return;
      toggle(button.dataset.asapProductHandle);
    });
    render(root);
  }

  function initializeAll() {
    document.querySelectorAll('[data-asap-compare-root]').forEach(initialize);
  }

  window.ASAPCompare = { toggle, getHandles: () => [...handles], clear };
  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
  if (document.readyState !== 'loading') initializeAll();
})();
